import React from "react";

const StatCard = ({ title, value, subtitle, icon, trend, trendLabel, color = "purple" }) => {
  const displayValue = value === null || value === undefined ? "—" : value;

  const colorGradients = {
    purple: "from-purple-500/20 to-purple-600/5 text-purple-600 dark:text-purple-400 border-purple-500/30",
    pink: "from-pink-500/20 to-pink-600/5 text-pink-600 dark:text-pink-400 border-pink-500/30",
    blue: "from-blue-500/20 to-blue-600/5 text-blue-600 dark:text-blue-400 border-blue-500/30",
    amber: "from-amber-500/20 to-amber-600/5 text-amber-600 dark:text-amber-400 border-amber-500/30"
  };

  return (
    <div className="neumorphic-card rounded-2xl p-5 border transition-all duration-300 hover:border-purple-500/30 hover:scale-[1.01] flex flex-col justify-between">
      <div className="flex items-start justify-between">
        <div>
          <span className="text-[11px] font-bold tracking-wider uppercase text-gray-500 dark:text-gray-400">
            {title}
          </span>
          <div className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white mt-1 tracking-tight">
            {displayValue}
          </div>
        </div>
        {icon && (
          <div className={`p-3 rounded-xl bg-gradient-to-br border ${colorGradients[color] || colorGradients.purple}`}>
            {icon}
          </div>
        )}
      </div>

      {(subtitle || trend !== undefined) && (
        <div className="mt-4 pt-3 border-t border-gray-100 dark:border-white/5 flex items-center justify-between text-xs">
          {subtitle && <span className="text-gray-500 dark:text-gray-400 font-medium">{subtitle}</span>}
          {trend !== undefined && (
            <span className={`font-semibold flex items-center gap-1 ${trend >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}>
              {trend >= 0 ? "↑" : "↓"} {Math.abs(trend)}% {trendLabel || ""}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default StatCard;
